import { render, staticRenderFns } from "./grant-stat.vue?vue&type=template&id=99557aa0&scoped=true&"
import script from "./grant-stat.vue?vue&type=script&lang=js&"
export * from "./grant-stat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99557aa0",
  null
  
)

export default component.exports